export default "__VITE_ASSET__oUkaECiJ__"